import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('MR'); // 'MR' or 'EN'
  
  const toggleLanguage = () => {
    setLanguage(prevLang => (prevLang === 'MR' ? 'EN' : 'MR'));
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);